// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"VerifyEmail_logoContainer__1uDCQ","logo":"VerifyEmail_logo__39DM_","link":"VerifyEmail_link__2d-hw","button":"VerifyEmail_button__3P9Hc"};